export enum ComponentViewQrCode {
  HOME = 'home',
  HISTORY = 'history',
  SCAN = 'scan',
  PRODUCT_LIST = 'product-list'
};